import { Group, LookupConfiguration } from "common/form/types";
import { Context } from "common/types/context";
import { getLayoutGroupColumns } from "common/form/functions/common";
import { isDrilldownValid } from "./drilldown/functions";
import { LookupTypeWithDefault, TypeOption } from "./types";
import { isUserDefinedValid } from "./user-defined/functions";

export const getLookupType = (
  context: Context,
  value?: LookupConfiguration,
): LookupTypeWithDefault | undefined => {
  if (
    value?.type === "drilldown" &&
    context.isEnabledFeature("drilldownLookups")
  ) {
    return "drilldown";
  }
  if (
    value?.type === "userDefined" &&
    context.isEnabledFeature("userDefinedLookups")
  ) {
    return "userDefined";
  }
  if (value?.type === "noLookup") {
    return "noLookup";
  }
  return undefined;
};

export const isFormValid = (
  type: LookupTypeWithDefault,
  lookupConfiguration?: LookupConfiguration,
): boolean => {
  if (type === "drilldown") {
    return isDrilldownValid(lookupConfiguration);
  }
  if (type === "userDefined") {
    return isUserDefinedValid(lookupConfiguration);
  }
  if (type === "noLookup") {
    return true;
  }
  return true;
};

export const getLookupTypeSelectorOptions = (
  context: Context,
): TypeOption[] => {
  const options: TypeOption[] = [
    { value: "foreignKey", label: _("System Lookup") },
  ];

  if (context.isEnabledFeature("userDefinedLookups")) {
    options.push({ value: "userDefined", label: _("User Defined Lookup") });
  }

  if (context.isEnabledFeature("drilldownLookups")) {
    options.push({ value: "drilldown", label: _("Drill Down") });
  }

  options.push({ value: "noLookup", label: _("No Lookup") });

  return options;
};

export const getOptionLabel = (option: TypeOption) => option.label;

export const getColumnsWithLookupConfig = (groups: Group[]): string[] =>
  getLayoutGroupColumns(groups).reduce<string[]>(
    (acc, lc) => (lc.lookupConfiguration ? [...acc, lc.columnName] : acc),
    [],
  );
